<div class="modal-header">
    <h4 class="modal-title">{{'LostConnectionmModal.title' | translate}}</h4>
</div>
<div class="lost-connect-body">
    <p>{{'error-message.error.authentication.code.0' | translate}}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default close-button" (click)="hide()">{{'LostConnectionmModal.close' | translate}}</button>
</div>
